export enum ViewMode {
  DRAFT,
  PUBLISHED
}
